import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import Heading from 'components/Typography/Heading';
import { DragModal } from 'components/DragModal/DragModal';
import { useExportImport } from '../../ExportImportContext';
import { NxtImport } from 'components/ExportImport/NxtImport/NxtImport';

export const ImportModal = memo(() => {
  const { t } = useTranslation();
  const exportImportContext = useExportImport();

  if (!exportImportContext) {
    // Import modal is optional, so if context is not available, we return null
    return null;
  }

  const {
    import: { importModalOpen, toggleImportModal },
  } = exportImportContext;

  return (
    <DragModal
      open={importModalOpen}
      title={t('blox.import.label')}
      onClose={toggleImportModal}
      isDraggable={false}
      isResizable={true}
      isFullscreenable={false}
      initialWidth={500}
      initialHeight={600}
      header={
        <Box
          data-testid="import-modal-header"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Heading>{t('blox.import.label')}</Heading>
        </Box>
      }
      body={<NxtImport handleClose={toggleImportModal} />}
    />
  );
});

ImportModal.displayName = 'ImportModal';
export default ImportModal;
